module.exports = __webpack_public_path__ + "images/assets/461927bc3b132d42c1d5293f53c016ab.svg";